import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import Icon from "../Assets/IconLibrary/Icon";
import {Articles} from "../Components/Contents/Articles";
import {Link} from "react-router-dom";
import MetaData from "../Components/MetaData/MetaData";

export default class Blog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previewLimit: 200,
            blogs: Articles
        }
    }

    render() {
        let {scrollToTop, setArticleID} = this.props;
        return (

            <div className="blog-layout">
                <MetaData keyword={"blogs"}/>
                <h1 className="section-title">
                    Blogs
                </h1>
                <div className="section-description quote">
                    <i>“Success is the sum of small efforts, repeated day in and day out.”</i> – Robert Collier

                </div>
                {
                    Object.keys(Articles).length > 1 &&
                    <div className="search-box">
                        <Icon name={"search"} size={14}/>
                        <input type={"text"} placeholder={"Search Blog"}/>
                    </div>
                }

                <div className="blog-list-container">
                    <div className="blog-list">
                        {
                            Object.keys(Articles).map((blogID, bid) =>
                                <GetBlogCard id={blogID} setArticleID={setArticleID} scrollToTop={scrollToTop}/>
                            )
                        }
                    </div>
                </div>
                {/*<Loading/>*/}
            </div>
        );
    }
}







export class GetBlogCard extends React.Component{

    checkURLAndScroll = () => {
        let {id, setArticleID, scrollToTop} = this.props;
        setArticleID(id);
        scrollToTop()
    }
    render() {

        let {id} = this.props;
        let blogInfo = Articles[id];
        let previewLimit = 300;
        return (
            <Link to={`/blog/${id}`} onClick={this.checkURLAndScroll.bind(this)}>
                <div className="blog-card">
                    <div className="blog-card-title">

                        {blogInfo.Title}
                    </div>
                    <div className="blog-card-image-container">
                        <div className="blog-card-image" style={{backgroundImage: `url(${blogInfo.Image})`}}/>
                    </div>
                    <div className="blog-card-info-row">
                        <div className="blog-card-info">
                            <img src={blogInfo.AuthorInfo.Image} alt={""}/>
                            <div className="blog-card-info-author">{blogInfo.AuthorInfo.Name}</div>
                        </div>
                        <div className="blog-card-info">
                            <div className="blog-card-info-date">{blogInfo.PublishedDate}</div>
                        </div>
                    </div>
                    <div className="blog-card-preview">
                        {
                            blogInfo.Preview.length <= previewLimit ?
                                blogInfo.Preview
                                :
                                <>
                                    {blogInfo.Preview.substring(0, previewLimit) + "..."}
                                    <span className={"blog-card-see-more-link"}>
                                                   View Details
                                               </span>
                                </>
                        }
                    </div>
                </div>
            </Link>
        )
    }

}